/**
 * Scroll-aware edge shadows for the cart drawer's pinned top and footer.
 *
 * Sets `is-scrolled` on <cart-drawer> while the panel is scrolled away from
 * the top (content hidden under the top band) and `has-more-below` while
 * there is content hidden under the footer. CSS fades the shadows on those
 * classes. Listens at the drawer root with capture because Dawn replaces
 * .drawer__inner (the scroll container) on every cart re-render.
 */
(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || drawer.__e13Shadows) return;
  drawer.__e13Shadows = true;

  let raf = null;
  const update = () => {
    raf = null;
    const inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    const remaining = inner.scrollHeight - inner.clientHeight - inner.scrollTop;
    drawer.classList.toggle('is-scrolled', inner.scrollTop > 2);
    drawer.classList.toggle('has-more-below', remaining > 2);
  };
  const schedule = () => {
    if (raf === null) raf = requestAnimationFrame(update);
  };

  drawer.addEventListener('scroll', schedule, { capture: true, passive: true });
  new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
})();
